/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * Sequence.web.tsx - Hint for sequence questions, shows a number line based on step size.
 */

import NumberLine100 from './NumberLine100';
import NumberLine10 from './NumberLine10';
import NumberLine5 from './NumberLine5';
import NumberLine3 from './NumberLine3';
import NumberLine2 from './NumberLine2';
import './Sequence.web.css';
import { SequenceProps } from './SequenceProps';


import type { JSX } from 'react';


const Sequence = ({format, answer, step}: SequenceProps): JSX.Element => {

  let numberLine;

  if(step === 10)
  {
    numberLine = <NumberLine10 format={format} answer={answer} key="numberLine"/>;
  }
  else if(step === 100)
  {
    numberLine = <NumberLine100 format={format} answer={answer} key="numberLine"/>;
  }
  else if(step === 5)
  {
    numberLine = <NumberLine5 format={format} answer={answer} key="numberLine"/>;
  }
  else if(step === 3)
  {
    numberLine = <NumberLine3 format={format} answer={answer} key="numberLine"/>;
  }
  else if (step === 2)
  {
    numberLine = <NumberLine2 format={format} answer={answer} key="numberLine"/>;
  }

  return (
    <div className="numberLineWrapper">
      {numberLine}
    </div>
  );
};

export default Sequence;
